export const getBound = (value, min, max)=>{
    if (min !== undefined && value === min) {
        if (max === min) {
            return 'both';
        }
        return 'min';
    } else if (max !== undefined && value === max) {
        return 'max';
    }
    return 'none';
};
